import { j as r } from "../../_virtual/jsx-runtime.js";
const n = ({
  width: t = 20,
  height: e = 20,
  viewBox: o = "0 0 20 20",
  fill: C = "currentColor",
  ...s
}) => /* @__PURE__ */ r.jsx("svg", { width: t, height: e, viewBox: o, fill: C, ...s, children: /* @__PURE__ */ r.jsx(
  "path",
  {
    d: "M12.557 10.4537C13.0173 10.4537 13.3904 10.8267 13.3904 11.287V16.4564C13.3904 16.9167 13.0173 17.2898 12.557 17.2898H7.55707C7.09683 17.2898 6.72373 16.9167 6.72373 16.4564L6.72373 11.287C6.72373 10.8267 7.09683 10.4537 7.55707 10.4537L12.557 10.4537ZM2.09204 7.32049C3.19502 4.00997 6.31872 1.62311 9.99984 1.62311C13.6811 1.62311 16.8048 4.00997 17.9078 7.32049L16.3262 7.84768C15.4438 5.19927 12.9448 3.28977 9.99984 3.28977C7.05495 3.28977 4.556 5.19927 3.67361 7.84768L2.09204 7.32049ZM5.25517 8.37486C5.91697 6.38856 7.79118 4.95644 9.99984 4.95644C12.2086 4.95644 14.0828 6.38856 14.7446 8.37486L13.163 8.90202C12.7218 7.57786 11.4723 6.62311 9.99984 6.62311C8.52742 6.62311 7.27794 7.57786 6.83675 8.90202L5.25517 8.37486ZM8.3904 12.1203L8.3904 15.6231H11.7237V12.1203H8.3904Z",
    fill: C
  }
) });
export {
  n as default
};
